export default {
  // 通用
  'pages.common.more': '更多',

  // 聲紋說話人 Speakers
  'pages.console.speakers.column.speaker': '說話人',
  'pages.console.speakers.column.samples': '樣本',
  'pages.console.speakers.error.sampleTooShort': '樣本過短，需至少2秒',
  'pages.console.speakers.error.recordFirst': '請先錄音或錄音無效',
  'pages.console.speakers.error.selectConversation': '請選擇對話音訊',
  'pages.console.speakers.msg.convUploadSuccess': '對話音訊上傳成功',
  'pages.console.speakers.msg.convUploadFailed': '對話音訊上傳失敗',
  'pages.console.speakers.msg.saveSuccess': '儲存成功',
  'pages.console.speakers.msg.saveFailed': '儲存失敗',
  'pages.console.speakers.modal.edit': '編輯',
  'pages.console.speakers.uploadFile': '上傳檔案',
  'pages.console.speakers.conversation': '對話音訊',
  'pages.console.speakers.stopRecording': '點選停止錄音',
  'pages.console.speakers.startRecording': '點選開始錄音',

  // 記憶觀察池 MemoryObservationCandidates
  'pages.memoryObservation.status.pending': '待觀察',
  'pages.memoryObservation.status.promoted': '已晉升',
  'pages.memoryObservation.status.rejected': '已拒絕',
  'pages.memoryObservation.status.decayed': '已衰減',
  'pages.memoryObservation.slot.age': '年齡',
  'pages.memoryObservation.slot.communicationStyle': '溝通風格',
  'pages.memoryObservation.slot.dislikes': '規避',
  'pages.memoryObservation.slot.family': '家庭',
  'pages.memoryObservation.slot.relationships': '關係',
  'pages.memoryObservation.slot.extra': '其他',
  'pages.memoryObservation.msg.loadFailed': '載入觀察池失敗',
  'pages.memoryObservation.msg.promoteSuccess': '已合併到長期畫像',
  'pages.memoryObservation.msg.promoteFailed': '晉升失敗',
  'pages.memoryObservation.msg.rejectSuccess': '已標記為拒絕',
  'pages.memoryObservation.msg.rejectFailed': '操作失敗',
  'pages.memoryObservation.loading': '載入觀察池…',
  'pages.memoryObservation.disabled.title': '觀察池未開啟',
  'pages.memoryObservation.disabled.desc':
    '在管理後臺「系統配置 → 應用程式」中開啟「長期記憶觀察池」後，跨會話採集的候選事實會在此列出，達到命中閾值可自動晉升，也可手動確認或拒絕。',
  'pages.memoryObservation.hint.autoPromotePrefix': '自動晉升需跨 ',
  'pages.memoryObservation.hint.autoPromoteMid': ' 個不同會話命中同一槽位；memoryCollectionDays（相容配置）：',
  'pages.memoryObservation.column.slot': '槽位',
  'pages.memoryObservation.column.content': '內容',
  'pages.memoryObservation.column.convCount': '會話數',
  'pages.memoryObservation.tag.promotable': '可晉升',
  'pages.memoryObservation.column.confidence': '置信',
  'pages.memoryObservation.column.source': '來源',
  'pages.memoryObservation.tag.fastLane': '快車道',
  'pages.memoryObservation.tag.collected': '採集',
  'pages.memoryObservation.column.device': '裝置',
  'pages.memoryObservation.column.convId': '會話ID',
  'pages.memoryObservation.column.createdAt': '建立時間',
  'pages.memoryObservation.column.lastSeen': '最後命中',
  'pages.memoryObservation.tooltip.lastSeen': '候選在對話中最近一次被強化/命中的時間',
  'pages.memoryObservation.column.status': '狀態',
  'pages.memoryObservation.column.action': '操作',
  'pages.memoryObservation.button.promote': '確認寫入',
  'pages.memoryObservation.button.reject': '拒絕',

  // 向量長期記憶錨點 LongTermMemoryAnchors
  'pages.memoryAnchors.msg.getStatusFailed': '獲取長期記憶狀態失敗',
  'pages.memoryAnchors.msg.getChunksFailed': '獲取長期記憶錨點失敗',
  'pages.memoryAnchors.msg.searchFailed': '檢索長期記憶失敗',
  'pages.memoryAnchors.msg.contentRequired': '記憶內容不能為空',
  'pages.memoryAnchors.msg.updateSuccess': '記憶錨點已更新',
  'pages.memoryAnchors.msg.updateFailed': '更新記憶錨點失敗',
  'pages.memoryAnchors.msg.deleteSuccess': '記憶錨點已刪除',
  'pages.memoryAnchors.msg.deleteFailed': '刪除記憶錨點失敗',
  'pages.memoryAnchors.clear.confirmTitle': '確認清空全部向量長期記憶？',
  'pages.memoryAnchors.clear.confirmContent':
    '該操作會刪除當前智慧體記憶庫中的所有摘要錨點，關閉長期記憶不會觸發此操作。刪除後不可恢復。',
  'pages.memoryAnchors.clear.confirmOk': '確認清空',
  'pages.memoryAnchors.clear.success': '已清空 {count} 條記憶錨點',
  'pages.memoryAnchors.clear.refreshFailed': '清空已成功，但重新整理列表失敗，請點選「重新整理錨點」重試',
  'pages.memoryAnchors.clear.failed': '清空長期記憶失敗',
  'pages.memoryAnchors.needSave': '儲存智慧體後才可以管理長期記憶錨點。',
  'pages.memoryAnchors.column.content': '內容',
  'pages.memoryAnchors.column.action': '操作',
  'pages.memoryAnchors.button.save': '儲存',
  'pages.memoryAnchors.button.edit': '編輯',
  'pages.memoryAnchors.button.delete': '刪除',
  'pages.memoryAnchors.button.refresh': '重新整理錨點',
  'pages.memoryAnchors.button.clearAll': '清空全部向量記憶',
  'pages.memoryAnchors.delete.confirmTitle': '確認刪除這條記憶錨點？',
  'pages.memoryAnchors.delete.confirmOk': '刪除',
  'pages.memoryAnchors.alert.title': '向量長期記憶庫',
  'pages.memoryAnchors.alert.desc': '這裡管理的是對話結束後自動寫入向量庫的摘要錨點；上方 JSON 是結構化畫像記憶，二者互相獨立。',
  'pages.memoryAnchors.tag.enabled': '已開啟',
  'pages.memoryAnchors.tag.disabled': '未開啟',
  'pages.memoryAnchors.tag.notCreated': '未建立',
  'pages.memoryAnchors.tag.systemOff': '系統開關關閉',
  'pages.memoryAnchors.search.placeholder': '輸入問題或關鍵詞，預覽長期記憶檢索結果',
  'pages.memoryAnchors.searchPreview': '檢索預覽',
  'pages.memoryAnchors.search.similarity': '相似度 {score}',

  // AgentMemorySetting 觀察池/向量錨點
  'pages.agentMemorySetting.observationPool.label': '觀察池候選',
  'pages.agentMemorySetting.observationPool.tooltip':
    '需在系統管理端開啟「長期記憶觀察池」。達到跨會話命中數可自動寫入畫像，也可在此手動確認或拒絕。',
  'pages.agentMemorySetting.vectorAnchor.label': '向量錨點',

  // AgentSetting 長期記憶畫像 placeholder 補充
  'pages.agentSetting.memory.longTerm.placeholder.birthday': '例如：3月15日、1990-05-20',
  'pages.agentSetting.memory.longTerm.placeholder.mbti': '例如：INTJ',
  'pages.agentSetting.memory.longTerm.placeholder.timezone': '例如：UTC+8',
  'pages.agentSetting.memory.longTerm.placeholder.communication_style': '例如：簡短、幽默',

  // AgentSetting 提供商商業授權
  'pages.agentSetting.provider.commercialLicenseRequired': '{name}（需商業授權）',

  // Agents 商業標籤
  'pages.agents.tag.commercial': '商業',

  // Settings OpenID
  'pages.settings.openid.label': 'OpenID：',

  // Devices 物聯卡狀態列舉釋義 + 複製提示
  'pages.devices.simState.hintWrap': '{raw}（{hint}）',
  'pages.devices.simState.sp.1': '移動',
  'pages.devices.simState.sp.2': '聯通',
  'pages.devices.simState.sp.3': '電信',
  'pages.devices.simState.cardForm.1': '插拔',
  'pages.devices.simState.cardForm.2': '陶瓷',
  'pages.devices.simState.cardForm.3': '貼片',
  'pages.devices.simState.cardForm.4': 'MP2',
  'pages.devices.simState.cardCl.1': '測試期',
  'pages.devices.simState.cardCl.2': '沉默期',
  'pages.devices.simState.cardCl.3': '正式期',
  'pages.devices.simState.cState.1': '停機',
  'pages.devices.simState.cState.2': '正常',
  'pages.devices.simState.cState.3': '待啟用',
  'pages.devices.simState.cState.4': '預銷戶',
  'pages.devices.simState.cState.5': '銷戶',
  'pages.devices.simState.cState.6': '休眠',
  'pages.devices.simState.cState.7': '申請銷戶',
  'pages.devices.simState.gprsState.1': '正常',
  'pages.devices.simState.gprsState.2': '關停，次月恢復',
  'pages.devices.simState.gprsState.3': '關停，次月不恢復',
  'pages.devices.simState.gprsState.4': '主動關停，系統不恢復',
  'pages.devices.copy.macTooltip': '複製完整 MAC',
  'pages.devices.copy.macCopiedTooltip': 'MAC 已複製',
  'pages.devices.copy.iccidTooltip': '複製 ICCID',
  'pages.devices.copy.iccidCopiedTooltip': 'ICCID 已複製',
};
